import React, { useState, useEffect } from 'react';
import { Form, Input, Modal, Radio, message } from 'antd';
import { postCategory } from '../../services/frontCategoryService';

function SecondModal(props) {
    const { onClose, visible, current, parentId, handleSuccess } = props || {};
    const { id, name, status } = current || {};
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
        },
    };

    function handleSubmit() {
        form.validateFields()
            .then(values => {
                if(submitting) return null;
                setSubmitting(true);
                postCategory({
                    ...values,
                    id: id || null,
                    parentId: parentId || current?.parentId,
                    priority: current?.priority || 0
                }).then(res => {
                    message.success('保存成功');
                    setSubmitting(false);
                    handleSuccess && handleSuccess();
                    onClose && onClose();
                }).catch(err => {
                    setSubmitting(false);
                })
            })
    }

    useEffect(() => {
        if(current) {
            form.setFieldsValue(current);
        }
    }, [current]);

    return (
        <Modal
            visible={visible}
            okText="保存"
            cancelText="取消"
            onCancel={onClose}
            onOk={handleSubmit}
            destroyOnClose={true}
            confirmLoading={submitting}
            maskClosable={false}
            title="二级类目"
        >
            <Form {...formItemLayout} form={form} initialValues={{status: 'ONLINE'}}>
                <Form.Item label='名称' name='name' rules={[{ required: true, message: '请输入类目名称' }]}>
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="状态" name='status'>
                    <Radio.Group>
                        <Radio value='ONLINE'>启用</Radio>
                        <Radio value='OFFLINE'>禁用</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default SecondModal;